<template>
  <!-- Begin Page Content -->
  <div class="container-fluid">

    <div class="card my-4">
      <div class="card-header row m-0">
        <div class="col">
          <h4>Хэрэглэгчийн эрх солих</h4>
        </div>

      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table
            class="table table-bordered"
            id="dataTable"
            width="100%"
            cellspacing="0"
            v-if="stores!=null && stores.length>0"
          >
            <thead>
              <tr>
                <th>№</th>
                <th>Хэрэглэгч</th>
                <th>Хүсэлт</th>
                <th>Огноо</th>
                <th>Төлөв</th>
                <th>Үйлдэл</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(store, index) in stores" v-bind:key="store.id">
                <td>{{index+1}}</td>
                <td>
                     <span v-if="store.userData!=null">
                     {{store.userData.name}},
                     {{store.userData.phone}}
                    </span>
                </td>
                <td>
                  <span v-if="store.type==0">
                    Хувь хүн байгууллагын эрх авах
                  </span>
                  <span v-if="store.type==1">
                    Байгууллага хувь хүн болох
                  </span>
                </td>
                <td>{{store.createdAt | formatDate}}</td>
                <td>
                  <span v-if="store.verified==true" class="badge badge-success">баталгаажсан</span>
                  <span v-else  class="badge badge-danger">баталгаажаагүй</span>

                </td>

                <td>
                  <div class="row">
                    <button v-if="store.loading==true" type="button"  class="btn btn-google btn-block" disabled>
                      <span class="spinner-border spinner-border-sm"></span>
                      Loading..
                    </button>
                    <button v-else class="btn btn-success btn-sm mx-1" @click="verifyStore(store, index)">Баталгаажуулах</button>
             
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-else class="alert alert-info text-center">Эрх солих хүсэлт ирээгүй байна.</div>
        </div>
        <button v-if="end==false" class="btn btn-block btn-success" @click="getItems()">Дараагийнх</button>
      </div>
    </div>


  </div>
  <!-- /.container-fluid -->
</template>

<script>
const fb = require("../../firebaseConfig.js");
import Vue from "vue";
import { mapState } from "vuex";
import { currentUser } from "../../firebaseConfig.js";
import moment from "moment";
export default {
  name: "RoleRequests",
  data() {
    return {
      msg: "RoleRequests",
      stores: [],
      end: false,
      lastVisible:null,
      firstVisible:null,
      loading:false,
      pageSize: 20


    };
  },
  computed: {
    ...mapState(["currentUser"])
  },
  created() {
    this.getItems();
  },
  methods: {
    _getImage(obj) {
      if (obj.images != null && obj.images != undefined) {
        return obj.images[0]["fileUrl"];
      }
    },
    async getItems(){
      if(this.end!=true){
        var querySnapshot;
        var first=false;
        if(this.lastVisible==null){
          querySnapshot=await fb.db.collection("rolerequests")
          .where("verified", "==", false)
          .orderBy("createdAt")
          .limit(this.pageSize).get();
          if(querySnapshot!=null && !querySnapshot.empty){
            this.firstVisible=querySnapshot.docs[0];
            first=true;
          }
        }
        else{
          querySnapshot=await fb.db.collection("rolerequests")
          .where("verified", "==", false)
          .orderBy("createdAt")
          .startAfter(this.lastVisible).limit(this.pageSize).get();
        }
        

        if(querySnapshot!=null && !querySnapshot.empty){

          if(first==true || ( this.firstVisible && this.firstVisible.id!=null && this.firstVisible.id!=querySnapshot.docs[0].id)){
            for(const itemDoc of querySnapshot.docs){
              let item=itemDoc.data();
              item.id=itemDoc.id;
              item.loading=false;
              item.userData=null;
              if(itemDoc.data().user!=null) 
                itemDoc.data().user.get().then((userDoc)=>{
                  if(userDoc.exists)
                    item.userData=userDoc.data();
                });
              this.stores.push(item);
            }
            this.lastVisible=querySnapshot.docs[querySnapshot.docs.length-1];
          }
          else
            this.end=true;
          
        }
      }
    },
    async verifyStore(request, index){
      if(request!=null && request.verified!=true){
        if(request.user!=null && request.type==0 && request.store!=null){
          request.loading=true;
          var user=await request.user.get();
          var store=await request.store.get();
          if(user.exists && store.exists){
            await user.ref.update({
              "isOrganization": true,
              "role": "store",
            });
            await store.ref.update({
              "isOrganization": true,
              "verified": true,
              
            });
            var storeUsers=await store.ref.collection("sharedOwners").get();
            if(storeUsers!=null && storeUsers!=undefined && !storeUsers.empty){
              for(const storeUser of storeUsers.docs){
                if(storeUser.exists){
                  if(storeUser.data().anonymous==true){
                    if(storeUser.data().connectedUser!=null && storeUser.data().connectedUser!=undefined){
                      storeUser.data().connectedUser.update({
                        "isOrganization": true,
                        "role": "store",
                      });
                    }
                  }
                  else{
                    if(storeUser.data().user!=null && storeUser.data().user!=undefined){
                      storeUser.data().user.update({
                        "isOrganization": true,
                        "role": "store",
                      });
                    }
                  }
                }
              }
            }
          
            await fb.db.collection("rolerequests").doc(request.id).delete();
            this.stores.splice(index, 1);
            alert("Хувь хүн байгууллага баталгаажлаа.");

          }

          
          request.loading=false;
        }
        else if(request.user!=null && request.type==1 && request.store!=null){
          request.loading=true;
          var user=await request.user.get();
          var store=await request.store.get();
          if(user.exists && store.exists){
            await user.ref.update({
              "isOrganization": false,
              "role": "user",
            });
            await store.ref.update({
              "isOrganization": false,
              "verified": true,
              
            });

            var storeUsers=await store.ref.collection("sharedOwners").get();
            if(storeUsers!=null && storeUsers!=undefined && !storeUsers.empty){
              for(const storeUser of storeUsers.docs){
                if(storeUser.exists){
                  if(storeUser.data().anonymous==true){
                    if(storeUser.data().connectedUser!=null && storeUser.data().connectedUser!=undefined){
                      storeUser.data().connectedUser.update({
                        "isOrganization": false,
                        "role": "user",
                      });
                    }
                  }
                  else{
                    if(storeUser.data().user!=null && storeUser.data().user!=undefined){
                      storeUser.data().user.update({
                        "isOrganization": false,
                        "role": "user",
                      });
                    }
                  }
                }
              }
            }
          
          
            await fb.db.collection("rolerequests").doc(request.id).delete();
            this.stores.splice(index, 1);
            alert("Байгууллага хувь хүн болж баталгаажлаа.");

          }

          
          request.loading=false;
        }

        
      }
    }
   
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).fromNow();
    }
  }
};
</script>